// @index('./*.ts', f => `export * from '${f.path}';`)
export * from './app.config';
export * from './captcha.config';
export * from './core-front.config';
export * from './language.config';
export * from './socket.config';
// @endindex